'use strict';
angular.module('cvsApp').service('validateDeepLinkService', ['networkService', 'validateDeepLinkModel', 'configservice', 'PageValues', function (NS, VDLM, config, PageValues) {

    function validateDeepLinkService() {
        this.validateDeepLink = function (callBackSuccess, messageID) {
            // var appConfig = config.appConfig();
            // PageValues.appConfig = appConfig;

			var url = PageValues.appConfig.parentHost + '/api/specialty/campaignRedirector/validateLink/v1';

            if (url === "URL_ERROR") {

            } else {
                var request = {
                    url: url,
                    header: {
						'Content-Type': 'application/xml'
                    },
                    data: requestBody(messageID),
                    onSuccess: callBackSuccess
                }
                cvsUtility.commonServiceCode(url, "validateDeepLink", VDLM, request, callBackSuccess, NS);
            }

        }

        var requestBody = function (messageID) {
			var apikey = PageValues.appConfig.newDeeplinkServiceConfig.apiKey;
            var Campaign = cvsUtility.queryMap.cmp;
			var xid = cvsUtility.queryMap.xid || PageValues.xid;
			var reqObj = {
				"validateLinkRequest": {
					"header":{
						"securityContext":{
							"apiKey": apikey,
						},
						"serviceContext":{
							"appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
							"lineOfBusiness": "Specialty",
							"serviceCors":"True", 
							"channelName": cvsUtility.queryMap.channel,
						}
					},
					"details":{
						"xid": xid,
						"campaignId":Campaign,
						"mode":"full"  
					}
				},
			};
			return cvsUtility.JSONToXml(reqObj);
        }
    }

    return new validateDeepLinkService();
}]);